import classNames from "../../../../classNames";

function CollectionTabs({ className, collectionName, onChangeTab }) {
  const collections = [
    { label: "Purchases", icon: "bi bi-cart3" },
    { label: "Sales", icon: "bi bi-graph-up-arrow" },
  ];

  return (
    <div className={classNames("", className)}>
      <div className="d-flex gap-2">
        {collections.map(({ label, icon }) => {
          const isActive = label === collectionName;
          return (
            <div
              key={label}
              onClick={() => onChangeTab(label)}
              className={classNames(
                "d-flex align-items-center gap-2 px-4 py-2 cursor-pointer position-relative",
                isActive ? "text-white fw-semibold" : "text-muted",
              )}
              style={{
                borderRadius: "10px 10px 0 0",
                backgroundColor: isActive ? "#4b5c7c" : "#e9ecef",
                userSelect: "none",
                transition: "all 0.2s ease",
                boxShadow: isActive
                  ? "0 -2px 8px rgba(75, 92, 124, 0.25)"
                  : "none",
                borderBottom: isActive ? "2px solid #4b5c7c" : "none",
                marginBottom: isActive ? "-1px" : "0",
                zIndex: isActive ? 2 : 1,
              }}
            >
              {isActive && (
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "#90caf9",
                    display: "inline-block",
                    marginLeft: "2px",
                  }}
                />
              )}

              <i
                className={icon}
                style={{ fontSize: "14px", opacity: isActive ? 1 : 0.5 }}
              />

              <span style={{ fontSize: "14px" }}>{label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CollectionTabs;
